import React from 'react'

import SearchStringOrIntReq from '../../../Classes/Models/Requests/SearchStringOrIntReq';
import SessionsApi from '../../../Classes/API/Administration/SessionsApi';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import AddmissionButton from 'layouts/AccountingSessions/AddmissionButton';

const ConfirmedAppointment = ({Appointment}) => {
  let navigate = useNavigate();
  const GoToAccSessionDetails = (AccSession) => {
    navigate(
      '/AccountingSessions/Details',
      {
        state: {
          SearchSession: AccSession,
        }
      }
    )
  }
  const ToggleSessionAdmission = async (AccSession) => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = AccSession.id;

    let res = await SessionsApi.ToggleAccountingSessionAdmission(req);

    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success");

      window.location.reload();
    }
    else {
      Swal.fire("Failed", res.message, "error");
    }
  }
  return (
    <MDBox>
            <span class="badge badge-success">CONFIRMED APPOINTMENT</span>

              <MDBox display="flex" py={1} pr={2}>

                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  Appointmentd ID :

                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;
                  {Appointment.id}
                </MDTypography>
              </MDBox>
              <MDBox display="flex" py={1} pr={2}>

                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  Patient:

                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;
                  {Appointment.getPatient.getUser.name}, (ID: {Appointment.getPatient.id})
                </MDTypography>
              </MDBox>

              <MDBox
                onClick={() => GoToAccSessionDetails(Appointment.getAccountingSession)}
                display="flex" py={1} pr={2}>
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  Accounting Session Id:

                </MDTypography>
                <MDTypography
                  variant="button" fontWeight="regular" color="text">
                  &nbsp;
                  {Appointment.getAccountingSession.id}
                </MDTypography>
              </MDBox>

              <MDBox display="flex" py={1} pr={2}>
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  Session name:
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;
                  {Appointment.getAccountingSession.getSession.name}
                </MDTypography>
              </MDBox>

              <MDBox py={1} pr={2}>
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  Addmission: 
                </MDTypography>
                <AddmissionButton AccSession={Appointment.getAccountingSession} />
                {/* <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;
                  {Appointment.getAccountingSession.isPaidFor ? (
                    <>
                      {Appointment.getAccountingSession.isAdmitted  ? (
                        <>
                          <span class="badge badge-success">ADMITTED</span>
                        <br/>
                      <button onClick={() => ToggleSessionAdmission(Appointment.getAccountingSession)} className="btn btn-warning">UnAddmit</button>
                      </>)
                      :(<>
                        <span class="badge badge-danger">NOT ADMITTED</span>
                        <br/>
                      <button onClick={() => ToggleSessionAdmission(Appointment.getAccountingSession)}  className="btn btn-success">Addmit</button>
                      </>)}
                    </>
                  ) : (
                      <button disabled={true} className="btn btn-danger">Session Not Paid</button>
                  )}
                </MDTypography> */}
              </MDBox>



            </MDBox>
  )
}

export default ConfirmedAppointment